import { useSelector } from "react-redux";

const usePageTranslation = () => {
  return useSelector((state: any) => state.commonSlice.PageTranslation.translationData);
};

export default usePageTranslation;